<template>
    <span>
        <b-button-group class="float-right">
            <b-button
                variant="success"
                @click="confirmarNovaFinalizacao()"
                v-if="$temAcessoView('CRED-FORN-FIN-01')"
                >Novo Registro de Pagamento</b-button
            >
        </b-button-group>
    </span>
</template>

<script>
export default {
    props: {
        finalizacoesServicos: {
            type: Object,
            default: () => ({})
        }
    },

    data() {
        return {}
    },
    methods: {
        inserirFinalizacao() {
            this.$store.dispatch('addRequest')
            this.finalizacoesServicos.inserirFinalizacao().then(response => {
                if (response) {
                    if (response.success) {
                        let finalizacaoId = response.data
                        this.$store.dispatch('setRecarregar', true)
                        this.$emit('detalharFinalizacao', finalizacaoId)
                    } else {
                        this.$toast.error(
                            response.errors[0],
                            'ERROR',
                            this.$toastConfig.error
                        )
                    }
                }
                this.$store.dispatch('removeRequest')
            })
        },

        confirmarNovaFinalizacao() {
            this.$swal({
                title: 'Nova Finalização',
                html: `Confirma a criação de um novo protocolo de pagamento?`,
                icon: 'warning',
                showCancelButton: true,
                confirmButtonColor: '#3085d6',
                cancelButtonColor: '#d33',
                confirmButtonText: 'Sim',
                cancelButtonText: 'Não'
            }).then(result => {
                if (result.value) {
                    this.inserirFinalizacao()
                }
            })
        }
    }
}
</script>
